"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isType_1 = require("./isType");
var getObjectDeepKeyValue = function (dotSeparatedKeys, objectOrArray) {
    if ((isType_1.isObject(objectOrArray) || isType_1.isArray(objectOrArray)) && isType_1.isString(dotSeparatedKeys)) {
        var keys = dotSeparatedKeys.split('.');
        var value_1 = objectOrArray;
        keys.forEach(function (key) {
            if (value_1[key] === undefined) {
                throw new Error("getObjectDeepKeyValue: \"" + key + "\" is undefined.");
            }
            else {
                value_1 = value_1[key];
            }
        });
        return value_1;
    }
    throw new Error('getObjectDeepKeyValue: "dotSeparatedKeys" is not a string or "objectOrArray" is not an object or array.');
};
exports.default = getObjectDeepKeyValue;
//# sourceMappingURL=getObjectDeepKeyValue.js.map